import { initialTableShow } from 'utils/settings';
import moment from 'moment';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'companyName',
    title: 'Company Name',
    show: true,
    width: 417,
    valuesExport: [
      'companyName',
      'status',
      'country',
      'website',
      'customerType'
    ]
  },
  {
    isSortable: true,
    field: 'healthStatus',
    title: 'Health Status',
    show: true,
    width: 152,
    valuesExport: ['healthStatus']
  },
  {
    isSortable: true,
    field: 'arr',
    title: 'ARR',
    show: true,
    fromToGroup: true,
    width: 96,
    valuesExport: ['arr']
  },
  {
    isSortable: true,
    field: 'requestedAt',
    title: 'Created Date',
    show: true,
    width: 152,
    valuesExport: ['requestedAt']
  },
  {
    isSortable: true,
    field: 'ageInMonths',
    title: 'Age In Months',
    show: true,
    fromToGroup: true,
    width: 176,
    valuesExport: ['ageInMonths']
  },
  {
    isSortable: true,
    field: 'nextBillingAt',
    title: 'Next Billing',
    show: true,
    width: 134,
    valuesExport: ['nextBillingAt']
  },
  {
    isSortable: true,
    field: 'requestedByName',
    title: 'Requested By',
    show: true,
    width: 332,
    valuesExport: ['requestedByName', 'requestedByRole', 'requestedByEmail']
  },
  {
    isSortable: true,
    field: 'cancellationReason',
    title: 'Cancellation Reason',
    show: true,
    width: 220,
    valuesExport: [
      'cancellationReason',
      'feedback',
      'missingFeatures',
      'likelyToReturn',
      'expensiveReasonComment'
    ]
  },
  {
    isSortable: true,
    field: 'likelyToReturn',
    title: 'Likely to return',
    show: true,
    fromToGroup: true,
    width: 180,
    valuesExport: ['likelyToReturn']
  },
  {
    isSortable: true,
    field: 'requestRemovedAt',
    title: 'Request to remove',
    show: true,
    width: 194,
    valuesExport: ['requestRemovedAt']
  },
  {
    isSortable: true,
    field: 'cancellationLag',
    title: 'Cancellation Lag',
    show: true,
    fromToGroup: true,
    width: 192,
    valuesExport: ['cancellationLag']
  }
];

export const exportConfigCancellations = {
  exportUrl: '/cs/cancellation/export',
  exportName: 'cancellations',
  exportFormat: 'zip'
};

export const defaultFilters = {
  search: '',
  plan: [],
  status: [],
  billingCycle: [],
  cancellationReason: [],
  accountManager: [],
  customerSuccessEngineer: [],
  companySize: [],
  healthStatus: [],
  requestedAt: {
    startDate: moment().subtract(1, 'month').format('MM/DD/YYYY'),
    endDate: moment().format('MM/DD/YYYY')
  },
  nextBillingAt: { startDate: null, endDate: null },
  requestRemovedAt: { startDate: null, endDate: null },
  requestedByRole: []
};

export const defaultNavigation = {
  fieldName: 'requestedAt',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage,
  ageInMonths: { from: '', to: '' },
  arr: { from: '', to: '' },
  cancellationLag: { from: '', to: '' },
  likelyToReturn: { from: '', to: '' }
};
